// Take viewport height on mobile into account - see https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
function setViewportWidth() {
  let vw = document.documentElement.clientWidth * 0.01;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}

function setViewportHeight() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// Set viewport height on resize
window.addEventListener('resize', setViewportWidth);
window.addEventListener('resize', setViewportHeight);

// Set viewport height on load
setViewportWidth();
setViewportHeight();

